import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=6e4d1916&lang=pug&"
import script from "./EventDetails.vue?vue&type=script&lang=ts&"
export * from "./EventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports